var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmbeddedVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8C7 7.44772 7.44772 7 8 7H16C16.5523 7 17 7.44772 17 8V16C17 16.5523 16.5523 17 16 17H8C7.44772 17 7 16.5523 7 16V8ZM8 8H10V10H8V8ZM10 11H8V13H10V11ZM8 14H10V16H8V14ZM16 8H14V10H16V8ZM14 11H16V13H14V11ZM16 14H14V16H16V14ZM5.09721 8.83534C5.28216 8.62994 5.26558 8.31351 5.06018 8.12856C4.85478 7.9436 4.53833 7.96018 4.35338 8.16559L1 12.0005L1.02 12.0185L4.3563 15.8344C4.54124 16.0398 4.85767 16.0564 5.06306 15.8715C5.26846 15.6865 5.28505 15.3701 5.1001 15.1647L2.34878 11.9984L5.09721 8.83534ZM18.9385 15.8714C18.7331 15.6865 18.7165 15.3701 18.9014 15.1647L21.6499 12.0016L18.8986 8.83532C18.7136 8.62992 18.7302 8.31349 18.9356 8.12855C19.141 7.94361 19.4574 7.96019 19.6424 8.16558L22.9787 11.9815L22.9987 11.9995L19.6453 15.8344C19.4603 16.0398 19.1439 16.0564 18.9385 15.8714Z",
    fill: "white",
    fillOpacity: 0.54
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedVideo);
export default __webpack_public_path__ + "static/media/embeddedVideo.82102895c16fcdd8a55cea9726f94db9.svg";
export { ForwardRef as ReactComponent };